/**
 * Default cancel reason used when user doesn't select a reason from the exit survey.
 * This is used for optional surveys and represents "Cancelled without exit survey response".
 */
export const DEFAULT_CANCEL_REASON_CODE = '114';
export const DEFAULT_CANCEL_REASON_TEXT = 'Cancelled without exit survey response';
export const DEFAULT_CANCEL_REASON = `${DEFAULT_CANCEL_REASON_CODE} | ${DEFAULT_CANCEL_REASON_TEXT}`;
